<template>
    <div class="view-container">
        <div v-if="order.id != null" class="app-container orderItemsContainer">
            <div v-for="item in order.items" :key="item.id + '-' + item.items.map(m => m.name)">
                <div v-if="item.imageURL" class="img-container">
                    <img :src="item.imageURL">
                </div>
                <div v-else class="img"></div>
                <h5>{{item.name}}</h5>
                <div class="badge-container">
                    <span class="badge">{{item.quantity}}</span>
                </div>
                <small>{{item.items.map(m => m.name).join(", ")}}</small>
                <h6 class="product-price">{{item.total.toFixed(2)}}</h6>
            </div>
            <div v-if="order.delivery == true" class="cartTotal text-right">
                <span>Delivery Fee: {{order.deliveryFee.toFixed(2)}}</span>
            </div>
            <div class="cartTotal text-right">
                <span>Service Fee: {{order.serviceFee.toFixed(2)}}</span>
            </div>
            <div class="cartTotal text-right">
                <span>Gratuity: {{order.gratuity.toFixed(2)}}</span>
            </div>
            <div class="cartTotal text-right">
                <span>Total: {{order.total.toFixed(2)}}</span>
            </div>
        </div>
    </div>
</template>
<!-- Scripts -->
<script>
export default {
  name: "Order",
  components: {
  },
  data() {
    return {
        id: Number,
        order: {}
    }
  },
  created() {
    if(localStorage.userMembershipID == null){
      this.$router.push({ path: 'Login', query: { returnUrl: "History" }});
    }
  },
  mounted() {
    var _self = this;

    _self.id = _self.getParameterByName('id');
    if(_self.id == Number)
        _self.$router.push('History');

    var data = {
        FranchiseID: localStorage.franchiseID,
        MembershipUserID: localStorage.userMembershipID,
        OrderID: _self.id
    }
    _self.$ooApi.orders.order.v1(data).then(function (result) {
        _self.order = result.data;
    });
  }
};
</script>
<style scoped>
    @import './Order.vue.css'; 
</style>
